import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-active"]
const _hoisted_2 = { class: "relative w-full h-full" }
const _hoisted_3 = { class: "flex justify-center items-center" }

import { ref, onMounted, onUnmounted } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'DropZone',
  emits: ["files-dropped"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const active = ref<boolean>(false);
let inActiveTimeout = null;

const setActive = () => {
    active.value = true;
    clearTimeout(inActiveTimeout);
};
const setInactive = () => {
    inActiveTimeout = setTimeout(() => {
        active.value = false;
    }, 50);
};

const onDrop = (e) => {
    setInactive();
    emit("files-dropped", [...e.dataTransfer.files] as File[]);
};

const preventDefaults = (e) => {
    e.preventDefault();
};

const events = ["dragenter", "dragover", "dragleave", "drop"];

onMounted(() => {
    events.forEach((eventName) => {
        document.body.addEventListener(eventName, preventDefaults);
    });
});

onUnmounted(() => {
    events.forEach((eventName) => {
        document.body.removeEventListener(eventName, preventDefaults);
    });
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      "data-active": active.value,
      onDragenter: _withModifiers(setActive, ["prevent"]),
      onDragover: _withModifiers(setActive, ["prevent"]),
      onDragleave: _withModifiers(setInactive, ["prevent"]),
      onDrop: _withModifiers(onDrop, ["prevent"])
    }, [
      _renderSlot(_ctx.$slots, "default", { dropZoneActive: active.value }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_overlay, {
          modelValue: active.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
          class: "align-center justify-center",
          contained: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_icon, {
                size: "25",
                color: "white"
              }, {
                default: _withCtx(() => _cache[1] || (_cache[1] = [
                  _createTextVNode("$fa-file-upload")
                ])),
                _: 1
              }),
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-white text-h5 font-weight-bold" }, " Déposez votre fichier ", -1))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ], 40, _hoisted_1)
  ]))
}
}

})